$(document).ready(function() {

  $("#open-pc-search").on("click", function() {
    $("body").addClass("SearchIsOpen");
    $(".search-pc").fadeToggle(300);
    $("#pc-search .search-bar input[type='search']").focus();
    $(".search-pc").addClass("fadedBody");
    $(window).scrollTop(0);
  });
  
  $(".luk-form").on("click", function() {
    $("body").removeClass("SearchIsOpen");
    $("#pc-search").fadeOut(300);
    $(".search-pc").removeClass("fadedBody");
  });

  $(".goBack a").on("click", function(e) {
    e.preventDefault();
    window.history.back();
  });


  $("#beskrivelse .lasMere").on("click", function() {
    $("#beskrivelse").removeClass("ofHid");
    $(this).remove();
  });

/*  $("#pc-search .search-bar input[type='search']").on("blur", function() {
    $(".search-pc").fadeOut(400).removeClass("fadedBody");
  });
*/
  
  if (window.history.length < 1) {
    $(".goBack").remove();
  }


  setTimeout(function() {
    var heightElem = $(".split-half-products .produkt-row").height();
    $(".bigImageRow").height(heightElem - 50);
  }, 250);


  $('.featured .btn').on('mouseover', function(){
    $(this).closest(".featured").addClass('is-hover');
  }).on('mouseout', function(){
    $(this).closest(".featured").removeClass('is-hover');
  });

  // Global dropdown function

  $(".drop-title").on("click", function() {
    $(this).next().slideToggle(250);  
  });

  (function() {
    $(".drop-title").next().hide().css({"margin":"0", "paddingBottom": "10px"});  
  })();

  function toggleInput(elem) {
    elem.focus();
  }

  $(".mobSearchOpen, .stickSearch input").on("click", function(e) {
    e.stopPropagation();
    e.preventDefault();

    toggleInput($(".stickSearch input[type='text']"));

    $("body").addClass("MobileSearchIsOpen");

    $(window).scrollTop(0);
  });
  
  

  $(".CloseStickSearch").on("click", function() {
    $(".stickSearch input[type='text']").blur();
    $(".clerk-live-search-container[data-template='@live-search']").hide();


    $("body").toggleClass("MobileSearchIsOpen");

    $(window).scrollTop(0);
  });

  $(window).on("scroll", function() {
    var headerHeight = $(".shopify-section-top-bar").height() + $(".site-header").height();

    var offSet = $(window).scrollTop();
    var shHeight = $(".site-header").height();
    if (offSet > headerHeight) {
      if (!$(".site-header").hasClass("fixed-header")) {

        $(".mobile-nav-bar").before("<div class='jumpFix'></div>");
        $(".jumpFix").height(shHeight);
        $(".mobile-nav-bar").addClass("mob-fixed-header");
        $(".site-header").addClass("fixed-header");
      }
    } else {
      $(".jumpFix").remove();
      $(".main-content").css("margin-top", "0px");
      $(".site-header").removeClass("fixed-header"); 
      $(".mobile-nav-bar").removeClass("mob-fixed-header");
    }
  }); 
 

    Clerk('on', 'rendered', 'span:not([data-template^="@live-search"])', function(data) {
      $('.own-clerk-slider').owlCarousel({
        loop:false,
        margin:0,
        navText : ["",""],
        dots: false,
        nav:true,
        responsive:{
          0:{
            items:2
          },
          600:{
            items:3
          },
          1000:{
            items: 5
          }
        }
      });
    });
  

  var mobileMenu = mobileMenu || {};


  mobileMenu.headerBoxes = (function() {

    var box = $(".headerBox");
    var cartBox = $(".headerBox--cart");
    var active = 'headerBox--active';

    box.on('click', function() {

      if (!$(this).hasClass(active)) {

        var type = $(this).attr('data-tab-label');

        if (type) {
          $(".headerBox").removeClass(active);

          $(this).addClass(active);

          $(".mobile-nav").attr('data-active-tab', type);
        }
      }
    });

    cartBox.on('click', function() {
      timber.LeftDrawer.close();
      ajaxCart.load();
    });

  })();
  
  
  
});



$(document).ready(function() {
  if (typeof WDN === 'undefined') {
    var WDN = {}; 
  }

  if (typeof WDN.stickySearchMobile === 'undefined') {
    WDN.stickySearchMobile = (function() {

      var stickySearchHide, stickySearchShow;

      stickySearchShow = function() {
        $("body").removeClass("sticky-search--hidden");
      }

      stickySearchHide = function(scroll) {
        if (scroll > 99) {
          $("body").addClass("sticky-search--hidden");
        }
      }

      var position = $(window).scrollTop(); 

      function getScrollDir() {
        var scroll = $(window).scrollTop();

        var _diff = (scroll - position);

        if (_diff > 49 || _diff < -49) {
          position = scroll;
        }


        if(_diff > 0) {
          stickySearchHide(scroll);
        } else if (_diff < 0) {
          stickySearchShow();
        } 
      }

      return {
        scrollListener: getScrollDir 
      }
    })();
  }


  $(window).scroll(function() {
    WDN.stickySearchMobile.scrollListener();
  });
  
  $("#AddToCart").on("click", function() {
    pintrk('track', 'addtocart');
  })
  ;
});
